import { useReveal } from "@/hooks/useReveal";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import About from "@/components/landing/About";
import Rooms from "@/components/landing/Rooms";
import HomestayEstate from "@/components/landing/HomestayEstate";
import RainDance from "@/components/landing/RainDance";
import Food from "@/components/landing/Food";
import Sitouts from "@/components/landing/Sitouts";
import Testimonials from "@/components/landing/Testimonials";
import Activities from "@/components/landing/Activities";
import Gallery from "@/components/landing/Gallery";
import Attractions from "@/components/landing/Attractions";
import Events from "@/components/landing/Events";
import Booking from "@/components/landing/Booking";
import Footer from "@/components/landing/Footer";
import FloatingButtons from "@/components/landing/FloatingButtons";

const Home = () => {
  useReveal();

  return (
    <div
      data-testid="home-page"
      className="relative bg-[#F8FAF7] text-[#1A1A1A]"
    >
      <Navbar />
      <main>
        <Hero />
        <About />
        <Rooms />
        <HomestayEstate />
        <RainDance />
        <Food />
        <Sitouts />
        <Testimonials />
        <Activities />
        <Gallery />
        <Attractions />
        <Events />
        <Booking />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default Home;
